import { Card } from '../../components/ui';

export default function SeccionGuia({ titulo, children }) {
  return (
    <Card>
      <h2>{titulo}</h2>
      {children}
    </Card>
  );
}